import { render, staticRenderFns } from "./DesktopAdminSlotCalendar.vue?vue&type=template&id=3b25ff8e&"
import script from "./DesktopAdminSlotCalendar.vue?vue&type=script&lang=js&"
export * from "./DesktopAdminSlotCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DesktopAdminSlotCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports